export enum EmailStatus {
	QUEUED = 'QUEUED',
	PROCESSED = 'PROCESSED',
	FAILED = 'FAILED',
	SKIPPED = 'SKIPPED',
	DELETED = 'DELETED'
}